import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import StoreStaffListSection from "./store-staff-list-section";
import { IStaffCMSVM, IStoreCmsVM } from "../../../../models/response/IStoreCmsResponse";
import { Row } from "react-bootstrap";

interface IProps {
  storeDetails: IStoreCmsVM;
  staffList: IStaffCMSVM[];
}

const StoreStaffTab = (props: IProps) => {
  return (
    <>
      <h1 className="fw-normal">
        {props.storeDetails.StoreName}
      </h1>

      <h2 className="fw-normal">
        <FormattedMessage id="Staff" />
      </h2>
      <Row  className="g-3">
        {props.staffList?.map((staff, index) => (
          <StoreStaffListSection key={index} staff={staff} storeDetails={props.storeDetails} />
        ))}
      </Row>
    </>
  );
};

export default StoreStaffTab;
